//
// Processing definitions for redux
//
// @see: processingActions.js
// @see: processingReducer.js

export const PROC_LOGOUT = 'logout';
export const PROC_LOGIN = 'login';

export const PROC_UPDATE_HOUSE = 'update-house';
export const PROC_CREATE_HOUSE = 'createData-house';
export const PROC_DELETE_HOUSE = 'delete-house';
export const PROC_LOAD_HOUSES = 'load-houses';
export const PROC_UPLOAD_HOUSE_LOGO = 'upload-house-logo';

export const PROC_CLEAR_CACHE_METADATA = 'proc-clear-cache-metadata';

export const PROC_LOAD_ACCESS = 'load-access';
export const PROC_CREATE_ACCESS = 'createData-access';
export const PROC_DELETE_ACCESS = 'delete-access';
export const PROC_UPDATE_ACCESS = 'update-acces';
export const PROC_PASSWORD_ACCESS = 'password-access';

export const PROC_TIMEZONES = 'loading-timezones';

export const PROC_SERVICE_LIST = 'load-service-list';
export const PROC_SERVICE_CREATE = 'createData-service';
export const PROC_SERVICE_RELATIONS = 'load-service-relations';
export const PROC_SERVICE_MOVEMENT = 'move-service';
export const PROC_SERVICE_DELETE = 'delete-service';
export const PROC_SERVICE_UPDATE = 'update-service';
export const PROC_SERVICE_UPDLOAD = 'upload-service-logo';

export const PROC_PARTS_LIST = 'load-part-list';
export const PROC_PARTS_CREATE = 'create-part';
export const PROC_PARTS_DELETE = 'delete-part';
export const PROC_PARTS_UPDATE_CHILDREN = 'update-part-children';
export const PROC_PARTS_UPDATE = 'update-part';

export const PROC_MODULES_FETCH = 'fetch-modules';
export const PROC_MODULES_UPDATE = 'update-module';

export const PROC_MODULE_FOR_HOUSES = 'module-for-houses';
export const PROC_SUPPORT_LOGIN = 'proc-support-login';

export const PROC_KFZ_FETCH = 'fetch-kfz';
export const PROC_KFZ = 'proc-kfz';
export const PROC_KFZ_UPLOAD = 'proc-kfz-upload';

export const PROC_KFZ_2_SERVICE = 'proc-kfz-service';


export const LOC_HOUSE_LIST_OPTIONS = 'house-list-options-v1';
export const LOC_ACCESS_LIST_OPIONS = 'access-list-options-v1';
export const LOC_KFZ_LIST = 'kfz-list-options-v1';
export const LOC_KFZ_MODEL_LIST = 'kfz-model-list-options-v1';
export const LOC_SERVICE_LIST = 'service-list-oprions-v1';

export const UPDATE_USER_LIST = 'user-list';
export const UPDATE_SERVICES_LIST = 'service-list';
export const UPDATE_SERVICES_RELATIONS = 'service-relation';
export const UPDATE_PARTS_LIST = 'parts-list';
export const UPDATE_PARTS_RELATIONS = 'parts-relations';
export const UPDATE_MODULES = 'modules-list';
export const UPDATE_KFZ = 'kfz-list';

export const CACHE_SERVICES = 1000 * 60 * 60;


// WEBPACK FOOTER //
// ./src/actions/index.js